import styled from 'styled-components'

export const Positioning = styled.div`
	position: absolute;
	inset: 0;
	pointer-events: none;

	display: grid;
	grid:
		".... .... ...." minmax(32px, 0.4fr)
		".... card ...." auto
		".... .... ...." minmax(32px, 0.6fr)
		/ minmax(32px, 0.5fr) auto minmax(32px, 0.5fr);

	> * {
		grid-area: card;
	}
`
